import React from 'react';

const AccountPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/account',
			exact: true,
			component: React.lazy(() => import('./AccountPage')),
		},
	],
};

export default AccountPageConfig;
